import {newSellerDailyReport,getMySellerDailyReport,getMyPayments,getMyRefunds} from "@/api/myaccount";

const state = {
}

const mutations = {
}

const actions = {
    getmypayments({commit},data) {
        return new Promise((resolve, reject) => {
            getMyPayments(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getmyrefunds({commit},data) {
        return new Promise((resolve, reject) => {
            getMyRefunds(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getmysellerdailyreport({commit},params) {
        return new Promise((resolve, reject) => {
            getMySellerDailyReport(params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    newsellerdailyreport({commit},params) {
        return new Promise((resolve, reject) => {
            newSellerDailyReport(params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

